import { ListFieldsKeys } from "../config";
import { strapiUrl } from "src/modules/users/constants";
import axios from "axios";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";

export const updateFile = (list: ListFieldsKeys, obj: any, strapiApi: string, strapiObj: any) => {
  return new Promise(async (resolve, reject) => {
    // 3. Обновляем этот же элемент
      const id = strapiObj.id;
      delete strapiObj['id'];

      let token: string | null = null;

      if (!isPWA()) {
        const result = await SecureStoragePlugin.get({ key: 'accessToken' });
        token = result.value;
      }

      const headers = {};

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      axios.put(
        `${strapiUrl}${strapiApi}/${id}`,
        {
          data: strapiObj,
        },
        {
          headers,
          withCredentials: true
        }
      ).then(() => {
        resolve(strapiObj.id);
      }).catch((err) => {
        reject(err);
      });
  });
};
